<template>
    <div class="c-view c-dashboard">
        <InternalHeader>
            <dashboard-create
                @add="handleAddDashboard"
                slot="actions"
                :dashboard-type-id="1"
            >
                <Button
                    slot="trigger"
                    custom-icon="icon icon-add"
                    class="text-primary"
                    >Add a Dashboard</Button
                >
            </dashboard-create>
            <div slot="title" class="c-internal-header__title">
                Dashboards
            </div>
        </InternalHeader>
        <div v-if="dashboards">
            <Row class="mt-5">
                <Col span="24">
                    <div v-if="owned.length > 0">
                        <h2 class="font-weight-normal">My Dashboards</h2>
                        <dashboard-list
                            class="mt-5"
                            :dashboards="owned"
                        ></dashboard-list>
                    </div>
                    <empty-state v-else class="text-center mt-8">
                        <dashboard-illustration
                            slot="illustration"
                            class="util-max-w200"
                        ></dashboard-illustration>
                        <p slot="text">
                            You don't have any dashboards yet.
                        </p>
                        <div slot="actions">
                            <dashboard-create
                                @add="handleAddDashboard"
                                :dashboard-type-id="1"
                            >
                                <Button
                                    slot="trigger"
                                    custom-icon="icon icon-add"
                                    type="primary"
                                    >Create your first Dashboard</Button
                                >
                            </dashboard-create>
                            <p v-if="0" class="mt-5 text-secondary">
                                Need help creating dashboards?
                                <a href="">Watch this video</a> or visit our
                                <a href="">Help Center</a>.
                            </p>
                        </div>
                    </empty-state>
                </Col>
            </Row>
            <Row class="mt-5" v-if="shared.length">
                <Col span="24">
                    <Divider></Divider>
                    <h2 class="font-weight-normal">Shared Dashboards</h2>
                    <dashboard-list
                        class="mt-5"
                        :dashboards="shared"
                    ></dashboard-list>
                </Col>
            </Row>
        </div>
        <loading-component v-else></loading-component>
    </div>
</template>

<script>
export default {
    props: {
        dashboardsRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/base.js"))(
                    window.akita.urls.api + "/v1/dashboards"
                );
            },
        },
        meDashboardsRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/me-dashboards.js"))();
            },
        },
    },
    data: function() {
        return {
            localStorageKey: "dashboards_default_general",
            dashboards: null,
        };
    },
    components: {
        DashboardCreate: function() {
            return import("@/js/components/partials/dashboard-create");
        },
        EmptyState: function() {
            return import("@/js/components/partials/empty-state");
        },
        DashboardIllustration: function() {
            return import("@/js/components/partials/illustrations/dashboard");
        },
        DashboardCreate: function() {
            return import("@/js/components/partials/dashboard-create");
        },
        DashboardList: function() {
            return import("@/js/components/partials/dashboard-list");
        },
        InternalHeader: function() {
            return import("@/js/components/partials/header");
        },
    },
    created() {
        this.init();
    },
    watch: {},
    computed: {
        account() {
            return _.chain(this.dashboards || [])
                .filter((dashboard) => {
                    return dashboard.is_account;
                })
                .orderBy(["name"], ["asc"])
                .value();
        },
        owned() {
            return _.chain(this.dashboards || [])
                .filter((dashboard) => {
                    return (
                        dashboard.user_id == this.$store.getters["me/ID"] &&
                        !dashboard.is_account
                    );
                })
                .orderBy(["name"], ["asc"])
                .value();
        },
        shared() {
            return _.chain(this.dashboards || [])
                .filter((dashboard) => {
                    return (
                        dashboard.user_id != this.$store.getters["me/ID"] &&
                        !dashboard.is_account
                    );
                })
                .orderBy(["name"], ["asc"])
                .value();
        },
    },
    methods: {
        async init() {
            let request = {
                params: {
                    q: ["version[eq]=2", "type_id[eq]=1"],
                    sort_by: "name:asc",
                    include: [],
                },
            };

            const response = await this.meDashboardsRepository.index(request);

            this.dashboards = response.data.data;

            /**
             * Is there a dashboard id in localstorage
             */
            let storedDashboardId = this.$localStorageCache.get(
                this.localStorageKey
            );

            /**
             * If this id exists in their list of available dashboards we should
             * redirect them there
             */
            if (_.find(this.dashboards, { id: storedDashboardId })) {
                this.$router.replace({
                    path: "/dashboards/" + storedDashboardId,
                });
            }
        },
        async handleAddDashboard(payload) {
            let response = await this.dashboardsRepository.store(payload);
            let dashboard = response.data.data;
            this.$Message.success({
                content: "New dashboard added.",
            });
            if (dashboard.type_id == 1) {
                this.$router.push({
                    path: "/dashboards/" + dashboard.id,
                });
            }
            this.$root.$emit("dashboard:add", dashboard);
        },
    },
};
</script>
